export default {
  computed: {
    perm () {
      const perm = this.$store.getters['auth/getPermissions']
      return perm
    },
    isOperator () {
      return this.perm.isOperator
    },
    canDeleteObjects () {
      return this.perm.canDeleteObjects
    },
    canReadObjects () {
      return this.perm.canReadObjects
    },
    canListObjects () {
      return this.perm.canListObjects
    },
    canCreateObjects () {
      return this.perm.canCreateObjects
    },
    canUpdateObjects () {
      return this.perm.canUpdateObjects
    },
    canWriteObjects () {
      return this.perm.canWriteObjects
    },
    canCreateUser () {
      return this.perm.canCreateUser
    },
    canDeleteUser () {
      return this.perm.canDeleteUser
    },
    canCreateAndDeleteUser () {
      return this.perm.canCreateAndDeleteUser
    },
    canUserAccessRemoteLog () {
      return this.perm.canUserAccessRemoteLog
    },
    canListUser () {
      return this.perm.canListUser
    },
    canUserExtractBackup () {
      return this.perm.canUserExtractBackup
    },
    canUserRestoreBackup () {
      return this.perm.canUserRestoreBackup
    },
    canUserUpdateFirmware () {
      return this.perm.canUserUpdateFirmware
    },
    isUserNSAuthorization () {
      return this.perm.isUserNSAuthorization
    },
    isUserToken () {
      return this.perm.isUserToken
    },
    isChangePasswordNextLogin () {
      return this.perm.isChangePasswordNextLogin
    }
  }
}
